export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm text-foreground-500 mb-8">欢迎投稿、合作咨询或反馈建议</p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            <div className="p-5 rounded-xl bg-background-100">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100/80 text-primary-600">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-800 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">商务合作与广告投放</p>
            </div>
            <div className="p-5 rounded-xl bg-background-100">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100/80 text-accent-600">
                <i className="ri-edit-line text-xl"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-800 mb-1">漫画投稿</h3>
              <p className="text-xs text-foreground-500">原创作者投稿通道</p>
            </div>
            <div className="p-5 rounded-xl bg-background-100">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-200/80 text-secondary-700">
                <i className="ri-feedback-line text-xl"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-800 mb-1">意见反馈</h3>
              <p className="text-xs text-foreground-500">问题反馈与功能建议</p>
            </div>
          </div>

          <a
            href="mailto:contact@kukanmh.com"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer no-underline"
          >
            <i className="ri-send-plane-line"></i>
            发送邮件
          </a>
        </div>
      </div>
    </section>
  );
}